import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getMetadata } from './activity-rules-metadata';

export const useMetadata = () => {
  const { t } = useTranslation();
  const metadata = useSelector((s: any) => s.filterMetaData.definition);
  return useMemo(() => getMetadata(metadata, t), [metadata, t]);
};
